'use client';

import { useRef } from 'react';

import { useWhitelabelConfig } from '@/hooks/useWhitelabelConfig';
import { BrandingKey } from '@/types/enums/WhitelabelConfig';

type PrintPolicyDrawerProps = {
  privacyPolicy: string;
  title?: string;
};

export const PrintPolicyDrawer = ({
  title = 'Política de Privacidade',
}: PrintPolicyDrawerProps) => {
  const printRef = useRef<HTMLDivElement>(null);
  const { getValue } = useWhitelabelConfig();
  const wlName = getValue(BrandingKey.BRANDING_NAME) ?? '';

  return (
    <div className="flex flex-grow flex-col gap-4 p-4 max-w-[1000px]">
      <div
        ref={printRef}
        className="prose prose-sm max-w-none text-foreground/90 max-h-[60vh] overflow-y-auto p-4"
      >
        <h2 className="mb-2">{title}</h2>
        <pre className="whitespace-pre-wrap break-words text-inherit">
          <div className="bg-background/50 px-6 rounded-md">
            <h1>POLÍTICA DE COOKIES</h1>
            <p>
              <strong>Última atualização:</strong> Novembro/2025
            </p>
            <div className="mt-4 p-4 flex flex-col gap-6 text-start mr-6">
              <section>
                <h2>1. INTRODUÇÃO</h2>
                <p className="mt-2 break-words">
                  A presente Política de cookies aplica-se ao site e seus subdomínios
                  (“Site”), de propriedade TVSBT CANAL 4 DE SAO PAULO S/A devidamente
                  inscrita no CNPJ sob o nº. 45.039.237/0001-14 , com sede na Avenida das
                  Comunicações, 4, no bairro Santa Fe, Osasco - SP, CEP 06.278-030 e
                  complementa os Termos de Uso e a Política de Privacidade do título de
                  capitalização na modalidade filantropia premiável “Quinzena de Prêmios”,
                  disponível no presente site, na qual trazemos a você mais informações
                  sobre nosso compromisso com a sua privacidade e a proteção dos seus
                  dados pessoais. Visando proporcionar uma experiência ainda mais
                  transparente em nosso site, explicando o conceito de Cookies, como os
                  utilizamos para melhorar sua navegação e, ainda, as possibilidades de
                  customização de uso. Caso não concorde com o uso de Cookies da forma
                  apresentada, você poderá: (i) ajustar as configurações de seu navegador
                  de internet para não permitir o uso de Cookies ou (ii) não acessar o
                  site. Se você tiver alguma dúvida sobre o processamento de suas
                  informações pessoais em nosso site, verifique nossa Política de
                  Privacidade.
                </p>
              </section>
              <section>
                <h2>2. O QUE SÃO COOKIES?</h2>
                <p className="mt-2 break-words">
                  Cookies são pequenos arquivos digitais, armazenados no computador do
                  Usuário/Cliente quando do seu acesso às páginas na Internet, contendo
                  uma sequência alfanumérica, que permitem ao Quinzena de Prêmios
                  identificar o Usuário/Cliente e tornar seu acesso mais rápido e
                  personalizado. Os cookies não são usados para determinar a identidade
                  pessoal de quem está apenas visitando nosso site. Eles servem para nos
                  ajudar a rastrear padrões de tráfego de dados, para determinar a
                  localização, recorrência de suas ações e outras variáveis que os
                  desenvolvedores consideram relevantes para tornar a sua experiência
                  muito mais eficiente. A propriedade TVSBT CANAL 4 DE SAO PAULO S/A
                  também reserva o direito de utilizar os cookies de terceiros para
                  proporcionar melhor experiência ou navegação e de prestação de serviços
                  ao Usuário/Cliente, bem como para fins publicitários.
                </p>
              </section>
              <section>
                <h2>3. POR QUE UTILIZAMOS COOKIES?</h2>
                <p className="mt-2 break-words">
                  O Portal {wlName} utiliza cookies com o intuito de identificar acessos
                  anteriores do Usuário/Cliente, para facilitar e aperfeiçoar seu acesso,
                  e o site, podendo, ainda esta tecnologia ser utilizada para fins de
                  publicidade direcionada. Nosso site usa cookies para melhorar o
                  desempenho e aprimorar a sua experiência de navegação. Certas áreas do
                  nosso site também usam cookies para entender mais sobre você, para que
                  possamos oferecer uma experiência de navegação mais personalizada.
                  <br />
                  <br />
                  Mais especificamente, usamos cookies e outras tecnologias de
                  rastreamento para os seguintes fins:
                  <br />
                  <br />
                  <li>Ajudar você na navegação</li>
                  <li>
                    Auxiliar no registro de nossos eventos, login e sua capacidade de
                    fornecer feedback
                  </li>
                  <li>Medir o uso do site (estatísticas e player de vídeo);</li>
                  <li>Facilitar o compartilhamento em redes sociais</li>
                  <li>
                    Ajudar com nossos esforços promocionais e de marketing (incluindo
                    publicidade comportamental) para fornecer conteúdo que seja mais
                    relevante para você e seus interesses.
                  </li>
                </p>
              </section>
              <section>
                <h2>4. QUAIS COOKIES COLETAMOS?</h2>
                <p className="mt-2 break-words">
                  Se você não deseja que seus dados sejam coletados e utilizados por meio
                  de cookies, você pode configurar seu navegador para bloquear ou
                  notificar você antes que um cookie seja armazenado em seu computador. A
                  maioria dos navegadores internet permite que você configure essa opção.
                  Consulte as instruções de configuração do seu navegador para obter mais
                  informações.
                </p>
                <h3 className="mt-4">DE SESSÃO</h3>
                <p className="mt-2 break-words">
                  São os cookies temporários que permanecem arquivados até que você saia
                  do site ou encerre o navegador.
                </p>
                <h3 className="mt-4">PERSISTENTES</h3>
                <p className="mt-2 break-words">
                  São os cookies que ficam armazenados no seu dispositivo até que sejam
                  excluídos (o tempo que o Cookie permanecerá no dispositivo depende do
                  seu tempo de vida e das configurações do seu navegador de internet).
                  Estes cookies ainda podem ser categorizados de acordo com a sua função.
                </p>
                <h3 className="mt-4">ESSENCIAIS</h3>
                <p className="mt-2 break-words">
                  Os cookies são essenciais para o funcionamento correto do nosso site e
                  para manter sua segurança. Essa opção está selecionada automaticamente,
                  pois sem eles, você não consegue navegar com o mínimo de adequação e há
                  risco de deixar de usar alguns recursos/funcionalidades básicas do fluxo
                  de navegação, razão pela qual, não é possível desabilitá-los. Esses
                  cookies não armazenam informações de identificação pessoal.
                </p>
                <h3 className="mt-4">MARKETING/PUBLICIDADE</h3>
                <p className="mt-2 break-words">
                  Esses cookies coletam informações de sua visita em nosso site para que
                  as propagandas nele dispostas sejam mais relevantes para você de acordo
                  com os seus interesses. Geralmente estão atrelados a Cookies de
                  terceiros. Caso você desabilite esses Cookies, no que diz respeito ao
                  site você ainda visualizará as publicidades, mas elas estarão menos
                  personalizadas. Ou seja, eles são adaptados às suas preferências,
                  aprimorando sua experiência e o funcionamento do nosso site.
                </p>
                <h3 className="mt-4">FUNCIONAL/PERSONALIZAÇÃO</h3>
                <p className="mt-2 break-words">
                  Esses cookies nos permitem oferecer recomendações de produtos, serviços
                  e conteúdo que correspondam melhor aos seus interesses e reflitam o seu
                  perfil. Com eles, conseguimos entender melhor suas escolhas e navegação.
                  Ao desativá-los, você está optando por uma personalização reduzida.
                </p>
                <p className="mt-2 break-words">
                  Eles também nos ajudam no gerenciamento de funcionalidades e
                  personalização aprimoradas. Eles podem ser definidos por nós ou por
                  fornecedores terceiros cujos serviços adicionamos às nossas páginas. Se
                  você não permitir esses cookies, algumas ou todas essas funcionalidades
                  poderão não funcionar corretamente.
                </p>
                <h3 className="mt-4">DE DESEMPENHO</h3>
                <p className="mt-2 break-words">
                  Estes cookies nos ajudam com o desempenho e o design do nosso site. Isso
                  nos permite medir quantas vezes uma página foi visitada e saber quais
                  páginas são as mais/menos relevantes para nossos usuários. Eles são
                  coletados por parceiros de terceiros e nos fornecem estatísticas sobre o
                  nosso site (como nossa taxa de erro, por exemplo). Todas as informações
                  que esses cookies coletam são anônimas. Se você não permitir esses
                  cookies, não saberemos quando você visitou nosso site.
                </p>
                <h3 className="mt-4">DE SEGMENTAÇÃO E RASTREAMENTO</h3>
                <p className="mt-2 break-words">
                  Estes cookies são definidos através do nosso site pelos nossos parceiros
                  de publicidade. Eles podem ser usados por essas empresas para criar um
                  perfil de seus interesses e lhe exibir anúncios relevantes em outros
                  sites. Eles não armazenam dados pessoais diretamente, mas são baseados
                  na identificação exclusiva do seu navegador e dispositivo de internet.
                  Se você não permitir esses cookies, estas funcionalidades poderão não
                  funcionar corretamente.
                </p>
                <p className="mt-2 break-words">
                  Esses cookies coletam informações relacionadas à origem da sua visita,
                  se você foi redirecionado por publicidade da TVSBT CANAL 4 DE SAO PAULO
                  S/A, que recurso de publicidade você viu, se você chegou direto ao nosso
                  site, o dispositivo utilizado (Desktop ou mobile), quais sistemas
                  operacionais estão em uso, além do tempo médio de acesso às nossas
                  páginas.
                </p>
                <p className="mt-2 break-words">
                  Esses cookies poderão ser utilizados em determinadas páginas do Nosso
                  Site para nos comunicarmos com você por meio de pop-ups, com base em seu
                  comportamento nos sites, agregando suas ações de publicidade e visitas a
                  serviços/produtos relevantes no futuro. As informações que recebemos são
                  todas agregadas e anônimas e podem incluir, por exemplo, dados
                  demográficos, comportamento on-line, interesses de compra e estatísticas
                  sobre a visitação do site.
                </p>
                <h3 className="mt-4">Informações de Cookies de Rastreamento</h3>
                <p className="mt-2 break-words">
                  O uso dos cookies para fins de segmentação e rastreamento é fornecido
                  por nossos parceiros.
                </p>
              </section>
              <section>
                <h2>5. BLOQUEIO DE COOKIES OU REVOGAÇÃO DE AUTORIZAÇÃO</h2>
                <p className="mt-2 break-words">
                  O Usuário/Cliente poderá a qualquer momento, restringir, bloquear ou
                  excluir algumas dessas tecnologias utilizadas para coleta automática dos
                  dados, por meio de configuração de seu navegador e do próprio site de
                  autorização. Caso ocorra o bloqueio, restrição ou a revogação de
                  autorização, esteja ciente de que, não poderá experimentar como
                  planejado, algumas das nossas facilidades, como por exemplo: Login
                  automático ao nosso site, facilidade de personalização do Nosso Site.
                  Caso você não deseje que seu cookie seja colocado em seu dispositivo,
                  você tem várias opções, como optar por não se preocupar em desativar os
                  cookies em nosso navegador de internet. Para maiores informações,
                  consulte a seção específica (abaixo) do navegador específico. Você
                  poderá configurar seus cookies com relação aos navegadores mais, pelos
                  meios descritos abaixo:
                </p>
                <p className="mt-2 break-words">
                  Para os cookies do &quot;Google Analytcs&quot;, você pode fazer download
                  do módulo acessível a partir do endereço a seguir para desativar esses
                  cookies:
                  <a
                    href="https://tools.google.com/dlpage/gaoptout/"
                    className="ml-1 underline"
                  >
                    https://tools.google.com/dlpage/gaoptout/
                  </a>
                </p>
                <p className="mt-2 break-words">
                  Para o Safari™:
                  <a
                    href="https://support.apple.com/kb/HT1677?viewlocale=en_US"
                    className="ml-1 underline"
                  >
                    https://support.apple.com/kb/HT1677?viewlocale=en_US
                  </a>
                </p>
                <p className="mt-2 break-words">
                  Para o Chrome™:
                  <a
                    href="https://support.google.com/chrome/answer/95647?hl=en"
                    className="ml-1 underline"
                  >
                    https://support.google.com/chrome/answer/95647?hl=en
                  </a>
                </p>
                <p className="mt-2 break-words">
                  Firefox™:
                  <a
                    href="https://support.mozilla.org/en-US/kb/enable-and-disable-cookies-website-preferences"
                    className="ml-1 underline"
                  >
                    https://support.mozilla.org/en-US/kb/enable-and-disable-cookies-website-preferences
                  </a>
                </p>
                <p className="mt-2 break-words">
                  Para o Opera™:
                  <a
                    href="http://help.opera.com/Windows/10.20/en/cookies.html"
                    className="ml-1 underline"
                  >
                    http://help.opera.com/Windows/10.20/en/cookies.html
                  </a>
                </p>
                <p className="mt-2 break-words">
                  TikTok -
                  <a
                    href="https://www.tiktok.com/legal/page/global-cookie-policy?lang=BR"
                    className="ml-1 underline"
                  >
                    https://www.tiktok.com/legal/page/global-cookie-policy?lang=BR
                  </a>
                </p>
                <p className="mt-2 break-words">
                  Threads -
                  <a
                    href="https://www.threads.com/cookie-policy"
                    className="ml-1 underline"
                  >
                    https://www.threads.com/cookie-policy
                  </a>
                </p>
                <p className="mt-2 break-words">
                  Para mais informações sobre a configuração de cookies:
                  <a href="http://www.aboutcookies.org/" className="ml-1 underline">
                    http://www.aboutcookies.org/
                  </a>
                </p>
                <p className="mt-2 break-words">
                  De fato, a maioria dos navegadores é configurada por padrão para aceitar
                  a instalação de cookies. No entanto, você tem a opção, se desejar, de
                  aceitar todos os cookies ou optar por não os receber sistematicamente.
                </p>
                <p className="mt-2 break-words">
                  Por favor, note, as versões de navegadores, os meios para configurar
                  cada navegador são diferentes. Eles estão descritos na seção Ajuda do
                  navegador, que permitirá que você saiba como alterar suas preferências
                  de cookies.
                </p>
                <p className="mt-2 break-words">
                  Ao se assegurar que os cookies permitem que você tenha uma melhor
                  experiência em nossos sites, sem eles, sua navegação pode se tornar
                  limitada e algumas funcionalidades dos sites podem ficar comprometidas.
                </p>
                <p className="mt-2 break-words">
                  Caso você utilize dispositivos diferentes para acessar o site
                  (Computador, celular, tablet, entre outros), deverá assegurar-se de que
                  cada navegador, de cada dispositivo, esteja ajustado para atender suas
                  preferências em relação aos Cookies.
                </p>
              </section>
              <section>
                <h2>6. ALGUMAS INFORMAÇÕES DETALHADAS E DESCRITIVAS SOBRE OS COOKIES</h2>
                <p className="mt-2 break-words">
                  Apresentamos abaixo para maior transparência e entendimento, tabelas com
                  os detalhes sobre os Cookies no site, bem como suas validades e
                  finalidades:
                </p>
                <h3 className="mt-4">6.1. COOKIES ESTRITAMENTE NECESSÁRIOS</h3>
                <div className="overflow-x-auto mt-2">
                  <table className="w-full table-auto border-collapse text-sm">
                    <thead>
                      <tr>
                        <th className="border px-3 py-2 text-left">Cookie Essenciais</th>
                        <th className="border px-3 py-2 text-left">Validade</th>
                        <th className="border px-3 py-2 text-left">Finalidade</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td className="border px-3 py-2">
                          <span className="underline">cookieconsent_status</span>
                        </td>
                        <td className="border px-3 py-2">2 Anos</td>
                        <td className="border px-3 py-2">
                          Gerado pelo plug-in de controle de aviso de cookies.
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <h3 className="mt-6">6.2. COOKIES MARKETING</h3>
                <div className="overflow-x-auto mt-2">
                  <table className="w-full table-auto border-collapse text-sm">
                    <thead>
                      <tr>
                        <th className="border px-3 py-2 text-left">Cookies Marketing</th>
                        <th className="border px-3 py-2 text-left">Validade</th>
                        <th className="border px-3 py-2 text-left">Finalidades</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td className="border px-3 py-2">
                          <span className="underline">1P_JAR</span>
                        </td>
                        <td className="border px-3 py-2">3 meses</td>
                        <td className="border px-3 py-2">
                          Este Cookie é utilizado pelo Google para a entrega de anúncios
                          de produtos, com ênfase em tempo real de leilões.
                        </td>
                      </tr>
                      <tr>
                        <td className="border px-3 py-2">
                          <span className="underline">ADS_VISITOR_ID</span>
                        </td>
                        <td className="border px-3 py-2">3 meses</td>
                        <td className="border px-3 py-2">
                          Este Cookie é utilizado pelo Google para a entrega de anúncios
                          de produtos, com ênfase em tempo real de leilões.
                        </td>
                      </tr>
                      <tr>
                        <td className="border px-3 py-2">
                          <span className="underline">AEC</span>
                        </td>
                        <td className="border px-3 py-2">3 meses</td>
                        <td className="border px-3 py-2">
                          Este Cookie é utilizado pelo Google para a entrega de anúncios
                          de produtos, com ênfase em tempo real de leilões.
                        </td>
                      </tr>
                      <tr>
                        <td className="border px-3 py-2">
                          <span className="underline">APISID</span>
                        </td>
                        <td className="border px-3 py-2">3 meses</td>
                        <td className="border px-3 py-2">
                          Este Cookie é utilizado pelo Google para a entrega de anúncios
                          de produtos, com ênfase em tempo real de leilões.
                        </td>
                      </tr>
                      <tr>
                        <td className="border px-3 py-2">
                          <span className="underline">HSID</span>
                        </td>
                        <td className="border px-3 py-2">3 meses</td>
                        <td className="border px-3 py-2">
                          Este Cookie é utilizado pelo Google para a entrega de anúncios
                          de produtos, com ênfase em tempo real de leilões.
                        </td>
                      </tr>
                      <tr>
                        <td className="border px-3 py-2">
                          <span className="underline">NID</span>
                        </td>
                        <td className="border px-3 py-2">3 meses</td>
                        <td className="border px-3 py-2">
                          Este Cookie é utilizado pelo Google para a entrega de anúncios
                          de produtos, com ênfase em tempo real de leilões.
                        </td>
                      </tr>
                      <tr>
                        <td className="border px-3 py-2">
                          <span className="underline">OGPC</span>
                        </td>
                        <td className="border px-3 py-2">3 meses</td>
                        <td className="border px-3 py-2">
                          Este Cookie é utilizado pelo Google para a entrega de anúncios
                          de produtos, com ênfase em tempo real de leilões.
                        </td>
                      </tr>
                      <tr>
                        <td className="border px-3 py-2">
                          <span className="underline">S</span>
                        </td>
                        <td className="border px-3 py-2">3 meses</td>
                        <td className="border px-3 py-2">
                          Este Cookie é utilizado pelo Google para a entrega de anúncios
                          de produtos, com ênfase em tempo real de leilões.
                        </td>
                      </tr>
                      <tr>
                        <td className="border px-3 py-2">
                          <span className="underline">SAPISID</span>
                        </td>
                        <td className="border px-3 py-2">3 meses</td>
                        <td className="border px-3 py-2">
                          Este Cookie é utilizado pelo Google para a entrega de anúncios
                          de produtos, com ênfase em tempo real de leilões.
                        </td>
                      </tr>
                      <tr>
                        <td className="border px-3 py-2">
                          <span className="underline">SEARCH_SAMESITE</span>
                        </td>
                        <td className="border px-3 py-2">3 meses</td>
                        <td className="border px-3 py-2">
                          Este Cookie é utilizado pelo Google para a entrega de anúncios
                          de produtos, com ênfase em tempo real de leilões.
                        </td>
                      </tr>
                      <tr>
                        <td className="border px-3 py-2">
                          <span className="underline">SID</span>
                        </td>
                        <td className="border px-3 py-2">3 meses</td>
                        <td className="border px-3 py-2">
                          Este Cookie é utilizado pelo Google para a entrega de anúncios
                          de produtos, com ênfase em tempo real de leilões.
                        </td>
                      </tr>
                      <tr>
                        <td className="border px-3 py-2">
                          <span className="underline">SIDCC</span>
                        </td>
                        <td className="border px-3 py-2">3 meses</td>
                        <td className="border px-3 py-2">
                          Este Cookie é utilizado pelo Google para a entrega de anúncios
                          de produtos, com ênfase em tempo real de leilões.
                        </td>
                      </tr>
                      <tr>
                        <td className="border px-3 py-2">
                          <span className="underline">SSID</span>
                        </td>
                        <td className="border px-3 py-2">3 meses</td>
                        <td className="border px-3 py-2">
                          Este Cookie é utilizado pelo Google para a entrega de anúncios
                          de produtos, com ênfase em tempo real de leilões.
                        </td>
                      </tr>
                      <tr>
                        <td className="border px-3 py-2">
                          <span className="underline">__Secure-1PAPISID</span>
                        </td>
                        <td className="border px-3 py-2">3 meses</td>
                        <td className="border px-3 py-2">
                          Este Cookie é utilizado pelo Google para a entrega de anúncios
                          de produtos, com ênfase em tempo real de leilões.
                        </td>
                      </tr>
                      <tr>
                        <td className="border px-3 py-2">
                          <span className="underline">__Secure-1PSID</span>
                        </td>
                        <td className="border px-3 py-2">3 meses</td>
                        <td className="border px-3 py-2">
                          Este Cookie é utilizado pelo Google para a entrega de anúncios
                          de produtos, com ênfase em tempo real de leilões.
                        </td>
                      </tr>
                      <tr>
                        <td className="border px-3 py-2">
                          <span className="underline">__Secure-1PSIDCC</span>
                        </td>
                        <td className="border px-3 py-2">3 meses</td>
                        <td className="border px-3 py-2">
                          Este Cookie é utilizado pelo Google para a entrega de anúncios
                          de produtos, com ênfase em tempo real de leilões.
                        </td>
                      </tr>
                      <tr>
                        <td className="border px-3 py-2">
                          <span className="underline">__Secure-1PSIDTS</span>
                        </td>
                        <td className="border px-3 py-2">3 meses</td>
                        <td className="border px-3 py-2">
                          Este Cookie é utilizado pelo Google para a entrega de anúncios
                          de produtos, com ênfase em tempo real de leilões.
                        </td>
                      </tr>
                      <tr>
                        <td className="border px-3 py-2">
                          <span className="underline">__Secure-3PAPISID</span>
                        </td>
                        <td className="border px-3 py-2">3 meses</td>
                        <td className="border px-3 py-2">
                          Este Cookie é utilizado pelo Google para a entrega de anúncios
                          de produtos, com ênfase em tempo real de leilões.
                        </td>
                      </tr>
                      <tr>
                        <td className="border px-3 py-2">
                          <span className="underline">__Secure-3PSID</span>
                        </td>
                        <td className="border px-3 py-2">3 meses</td>
                        <td className="border px-3 py-2">
                          Este Cookie é utilizado pelo Google para a entrega de anúncios
                          de produtos, com ênfase em tempo real de leilões.
                        </td>
                      </tr>
                      <tr>
                        <td className="border px-3 py-2">
                          <span className="underline">__Secure-3PSIDCC</span>
                        </td>
                        <td className="border px-3 py-2">3 meses</td>
                        <td className="border px-3 py-2">
                          Este Cookie é utilizado pelo Google para a entrega de anúncios
                          de produtos, com ênfase em tempo real de leilões.
                        </td>
                      </tr>
                      <tr>
                        <td className="border px-3 py-2">
                          <span className="underline">__Secure-3PSIDTS</span>
                        </td>
                        <td className="border px-3 py-2">3 meses</td>
                        <td className="border px-3 py-2">
                          Este Cookie é utilizado pelo Google para a entrega de anúncios
                          de produtos, com ênfase em tempo real de leilões.
                        </td>
                      </tr>
                      <tr>
                        <td className="border px-3 py-2">
                          <span className="underline">_fbp</span>
                        </td>
                        <td className="border px-3 py-2">3 meses</td>
                        <td className="border px-3 py-2">
                          Este Cookie é utilizado pelo Facebook para a entrega de anúncios
                          de produtos, com ênfase em tempo real de leilões.
                        </td>
                      </tr>
                      <tr>
                        <td className="border px-3 py-2">
                          <span className="underline">c_user</span>
                        </td>
                        <td className="border px-3 py-2">3 meses</td>
                        <td className="border px-3 py-2">
                          Este Cookie é utilizado pelo Facebook para a entrega de anúncios
                          de produtos, com ênfase em tempo real de leilões.
                        </td>
                      </tr>
                      <tr>
                        <td className="border px-3 py-2">
                          <span className="underline">datr</span>
                        </td>
                        <td className="border px-3 py-2">3 meses</td>
                        <td className="border px-3 py-2">
                          Este Cookie é utilizado pelo Facebook para a entrega de anúncios
                          de produtos, com ênfase em tempo real de leilões.
                        </td>
                      </tr>
                      <tr>
                        <td className="border px-3 py-2">
                          <span className="underline">dpr</span>
                        </td>
                        <td className="border px-3 py-2">3 meses</td>
                        <td className="border px-3 py-2">
                          Este Cookie é utilizado pelo Facebook para a entrega de anúncios
                          de produtos, com ênfase em tempo real de leilões.
                        </td>
                      </tr>
                      <tr>
                        <td className="border px-3 py-2">
                          <span className="underline">fr</span>
                        </td>
                        <td className="border px-3 py-2">3 meses</td>
                        <td className="border px-3 py-2">
                          Este Cookie é utilizado pelo Facebook para a entrega de anúncios
                          de produtos, com ênfase em tempo real de leilões.
                        </td>
                      </tr>
                      <tr>
                        <td className="border px-3 py-2">
                          <span className="underline">oo</span>
                        </td>
                        <td className="border px-3 py-2">3 meses</td>
                        <td className="border px-3 py-2">
                          Este Cookie é utilizado pelo Facebook para a entrega de anúncios
                          de produtos, com ênfase em tempo real de leilões.
                        </td>
                      </tr>
                      <tr>
                        <td className="border px-3 py-2">
                          <span className="underline">presence</span>
                        </td>
                        <td className="border px-3 py-2">3 meses</td>
                        <td className="border px-3 py-2">
                          Este Cookie é utilizado pelo Facebook para a entrega de anúncios
                          de produtos, com ênfase em tempo real de leilões.
                        </td>
                      </tr>
                      <tr>
                        <td className="border px-3 py-2">
                          <span className="underline">sb</span>
                        </td>
                        <td className="border px-3 py-2">3 meses</td>
                        <td className="border px-3 py-2">
                          Este Cookie é utilizado pelo Facebook para a entrega de anúncios
                          de produtos, com ênfase em tempo real de leilões.
                        </td>
                      </tr>
                      <tr>
                        <td className="border px-3 py-2">
                          <span className="underline">wd</span>
                        </td>
                        <td className="border px-3 py-2">3 meses</td>
                        <td className="border px-3 py-2">
                          Este Cookie é utilizado pelo Facebook para a entrega de anúncios
                          de produtos, com ênfase em tempo real de leilões.
                        </td>
                      </tr>
                      <tr>
                        <td className="border px-3 py-2">
                          <span className="underline">xs</span>
                        </td>
                        <td className="border px-3 py-2">3 meses</td>
                        <td className="border px-3 py-2">
                          Este Cookie é utilizado pelo Facebook para a entrega de anúncios
                          de produtos, com ênfase em tempo real de leilões.
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <h3 className="mt-6">6.3. COOKIES ANALÍTICOS</h3>
                <div className="overflow-x-auto mt-2">
                  <table className="w-full table-auto border-collapse text-sm">
                    <thead>
                      <tr>
                        <th className="border px-3 py-2 text-left">Outros Cookies</th>
                        <th className="border px-3 py-2 text-left">Validade</th>
                        <th className="border px-3 py-2 text-left">Finalidade</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td className="border px-3 py-2">
                          <span className="underline">_ga</span>
                        </td>
                        <td className="border px-3 py-2">2 Anos</td>
                        <td className="border px-3 py-2">
                          Este Cookie registra um ID único que é usado para gerar dados
                          estatísticos sobre como os visitantes utilizam o site. (Google
                          Analytics)
                        </td>
                      </tr>
                      <tr>
                        <td className="border px-3 py-2">
                          <span className="underline">_ga_BTF96LBRVY</span>
                        </td>
                        <td className="border px-3 py-2">1 Dia</td>
                        <td className="border px-3 py-2">
                          Este Cookie é utilizado para contar quantas vezes um website foi
                          visitado por diferentes visitantes; isso é feito atribuindo um
                          valor de identificação, para que os visitantes que retornam
                          possam ser identificados. (Google Analytics)
                        </td>
                      </tr>
                      <tr>
                        <td className="border px-3 py-2">
                          <span className="underline">_ga_B8B5KQBH4PZ</span>
                        </td>
                        <td className="border px-3 py-2">1 Dia</td>
                        <td className="border px-3 py-2">
                          Este Cookie é utilizado para contar quantas vezes um website foi
                          visitado por diferentes visitantes; isso é feito atribuindo um
                          valor de identificação, para que os visitantes que retornam
                          possam ser identificados. (Google Analytics)
                        </td>
                      </tr>
                      <tr>
                        <td className="border px-3 py-2">
                          <span className="underline">_ga_GGCCLYEKP2</span>
                        </td>
                        <td className="border px-3 py-2">1 Dia</td>
                        <td className="border px-3 py-2">
                          Este Cookie é utilizado para contar quantas vezes um website foi
                          visitado por diferentes visitantes; isso é feito atribuindo um
                          valor de identificação, para que os visitantes que retornam
                          possam ser identificados. (Google Analytics)
                        </td>
                      </tr>
                      <tr>
                        <td className="border px-3 py-2">
                          <span className="underline">_ga_GUHRGGQDP5</span>
                        </td>
                        <td className="border px-3 py-2">1 Dia</td>
                        <td className="border px-3 py-2">
                          Este Cookie é utilizado para contar quantas vezes um website foi
                          visitado por diferentes visitantes; isso é feito atribuindo um
                          valor de identificação, para que os visitantes que retornam
                          possam ser identificados. (Google Analytics)
                        </td>
                      </tr>
                      <tr>
                        <td className="border px-3 py-2">
                          <span className="underline">_ga_PG3KZVVP6Q</span>
                        </td>
                        <td className="border px-3 py-2">1 Dia</td>
                        <td className="border px-3 py-2">
                          Este Cookie é utilizado para contar quantas vezes um website foi
                          visitado por diferentes visitantes; isso é feito atribuindo um
                          valor de identificação, para que os visitantes que retornam
                          possam ser identificados. (Google Analytics)
                        </td>
                      </tr>
                      <tr>
                        <td className="border px-3 py-2">
                          <span className="underline">_ga_RQXSEJUFQ59</span>
                        </td>
                        <td className="border px-3 py-2">1 Dia</td>
                        <td className="border px-3 py-2">
                          Este Cookie é utilizado para contar quantas vezes um website foi
                          visitado por diferentes visitantes; isso é feito atribuindo um
                          valor de identificação, para que os visitantes que retornam
                          possam ser identificados. (Google Analytics)
                        </td>
                      </tr>
                      <tr>
                        <td className="border px-3 py-2">
                          <span className="underline">_ga_X6LMKVQRYQ</span>
                        </td>
                        <td className="border px-3 py-2">1 Ano</td>
                        <td className="border px-3 py-2">
                          Este Cookie é utilizado para contar quantas vezes um website foi
                          visitado por diferentes visitantes; isso é feito atribuindo um
                          valor de identificação, para que os visitantes que retornam
                          possam ser identificados. (Google Analytics)
                        </td>
                      </tr>
                      <tr>
                        <td className="border px-3 py-2">
                          <span className="underline">_gat_gtag_UA</span>
                        </td>
                        <td className="border px-3 py-2">1 Ano</td>
                        <td className="border px-3 py-2">
                          Este Cookie é utilizado para controlar a taxa de solicitações ao
                          Google Analytics.
                        </td>
                      </tr>
                      <tr>
                        <td className="border px-3 py-2">
                          <span className="underline">_gid</span>
                        </td>
                        <td className="border px-3 py-2">1 Dia</td>
                        <td className="border px-3 py-2">
                          Este Cookie é utilizado para contar quantas vezes um website foi
                          visitado por diferentes visitantes; isso é feito atribuindo um
                          valor de identificação, para que os visitantes que retornam
                          possam ser identificados. (Google Analytics)
                        </td>
                      </tr>
                      <tr>
                        <td className="border px-3 py-2">
                          <span className="underline">_hjSessionUser_3616434</span>
                        </td>
                        <td className="border px-3 py-2">1 Ano</td>
                        <td className="border px-3 py-2">
                          Este Cookie é utilizado pelo Hotjar para manter um ID de usuário
                          persistente, garantindo que o comportamento em visitas
                          subsequentes seja atribuído ao mesmo usuário.
                        </td>
                      </tr>
                      <tr>
                        <td className="border px-3 py-2">
                          <span className="underline">_hjSession_3616434</span>
                        </td>
                        <td className="border px-3 py-2">2 Anos</td>
                        <td className="border px-3 py-2">
                          Este Cookie é utilizado pelo Hotjar para armazenar dados de
                          sessão, como páginas visitadas e interações, para análise de
                          uso.
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </section>
              <section>
                <h2>7. DISPOSIÇÕES FINAIS</h2>
                <p className="mt-2 break-words">
                  Ressaltamos que esta Política de Cookies poderá ser modificada a
                  qualquer tempo pela TVSBT CANAL 4 DE SAO PAULO S/A. As mudanças entrarão
                  em vigor logo após a publicação. Se qualquer alteração exigir seu
                  consentimento, faremos uma solicitação para que você forneça esse novo
                  consentimento.
                </p>
                <p className="mt-2 break-words">
                  Em caso de dúvidas sobre esta Política de Cookies, entre em contato com
                  nosso DPO pelo
                  <a href="mailto:dpo@sbt.com.br" className="ml-1 underline">
                    e-mail
                  </a>
                  .
                </p>
              </section>
            </div>
          </div>
        </pre>
      </div>

      {/*<div className="text-xs text-foreground/60 border-t pt-3">*/}
      {/*  <p>*/}
      {/*    <strong>Data de impressão:</strong> {dayjs().format('DD/MM/YYYY HH:mm')}*/}
      {/*  </p>*/}
      {/*  <p className="mt-1">*/}
      {/*    Este documento foi gerado automaticamente e contém a versão mais atual da*/}
      {/*    política de privacidade.*/}
      {/*  </p>*/}
      {/*</div>*/}
    </div>
  );
};
